export const sessionIdSelector = (state) => state.getIn(['authorization', 'sessionId'])
export const userEmailSelector = (state) => state.getIn(['authorization', 'user', 'email'])
